import { render, staticRenderFns } from "./BlockPlaceholder.vue?vue&type=template&id=18119400"
import script from "./BlockPlaceholder.vue?vue&type=script&lang=js"
export * from "./BlockPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./BlockPlaceholder.vue?vue&type=style&index=0&id=18119400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports